import { memo, useState } from 'react'

import { Nullable } from '@types'

import { getShortlistNextSortOrder } from '@modules/shortlist/constants'
import { ShortlistSortOrder } from '@modules/shortlist/types'
import ModeIcon from '@mui/icons-material/Mode'
import { Box, Typography } from '@mui/material'

import SortArrow from './SortArrow'
import { StyledTitle } from './index.styles'

export interface CustomColumnHeadCellProps {
  sortOrder?: ShortlistSortOrder
  isSortActive: boolean
  onSortChange: (params: { customFieldId?: number; sortOrder?: ShortlistSortOrder }) => void
  headerTitle?: string
  onEditCustomColumnButtonClick?: (event: Nullable<React.MouseEvent<HTMLElement>>, id: number) => void
  customFieldId?: number
}

const CustomColumnHeadCell = ({
  onEditCustomColumnButtonClick,
  sortOrder,
  isSortActive,
  headerTitle,
  customFieldId,
  onSortChange,
}: CustomColumnHeadCellProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const nextSortOrder = getShortlistNextSortOrder(isSortActive, sortOrder)

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ cursor: 'pointer', flex: '1' }}
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        onSortChange?.({ customFieldId, sortOrder: nextSortOrder })
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography variant="h3">
        <StyledTitle>{headerTitle}</StyledTitle>
      </Typography>
      <Box
        onClick={e => {
          onEditCustomColumnButtonClick?.(e, customFieldId!)
          e.preventDefault()
          e.stopPropagation()
        }}
        display="flex"
        id="shortlist-edit_custom_column"
      >
        <ModeIcon sx={{ cursor: 'pointer', paddingLeft: '4px' }} fontSize="small" color="primary" />
      </Box>
      <SortArrow
        isActive={isSortActive}
        order={isSortActive ? sortOrder : null}
        isHovered={isHovered}
        fieldName="custom-column"
      />
    </Box>
  )
}

export default memo(CustomColumnHeadCell)
